import '../i18n';
import {useTranslation} from 'react-i18next';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

function Verified() {
    const {t: lnT} = useTranslation();

    const history = useHistory();
    const redirect = () => {
        history.push('/login');
    };

    useEffect(() => {
        setTimeout(() => {
            redirect();
        }, 2000);
    }, []);

    return (
        <div
            style={{
                backgroundColor: '#fafafa',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex'
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ fontSize: 18, fontWeight: 500 }}>{lnT('common:yourAccountHasBeenVerified')}</div>
                <div style={{ marginTop: 16 }}>{lnT('common:youWillBeRedirectedToLuckynoteIn')}</div>
                {/* <div onClick={() => redirect()}>Redirect now</div> */}
            </div>
        </div>
    );
}

export default Verified;
